import { IEnvironmentFromFile } from './environment.types'

export const environmentProd: IEnvironmentFromFile = {
  ADOBE_DTM: 'launch-EN4b0cc1c046db4a3da7308feed4637416.min',
  IDS_AUTH_KEY: 'oxford-user:https://identity-production.cinch.co.uk:fe',
  AUTH0_AUTH_KEY:
    'oxford-user:https://auth.cinch.co.uk:B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7',
  CINCHCARE_SERVICE_URL: 'https://cinchcare.cnv-prod.aws.cinch.co.uk',
  PERMISSION_URL: 'https://permissions.snc-prod.aws.cinch.co.uk/unsubscribe',
  DELIVERY_SERVICE_URL: 'https://delivery.api.cinch.co.uk',
  ORDER_SERVICE_URL: 'https://orders.api.cinch.co.uk',
  PROFILE_SERVICE_URL: 'https://profile.onr-prod.aws.cinch.co.uk',
  SEARCH_SERVICE_URL: 'https://search-api.snc-prod.aws.cinch.co.uk',
  SEARCH_CHANNEL_ID: 'CINCH',
  SETTLEMENT_SERVICE_URL: 'https://settlement.api.cinch.co.uk',
  SEGMENT_KEY: 'fxuC9PcNxIbVcTp5QHTWYF9QggSg3Mvs',
  STATIC_ASSETS_URL: 'https://assets-production.cinch.co.uk',
  IDENTITY_SERVICE_URL: 'https://api-production.cinch.co.uk/idt/v1',
  AUTH0_SERVICE_URL: 'https://auth.cinch.co.uk',
  AUTH0_DATABASE_NAME: 'Username-Password-Authentication',
  AUTH0_CLIENT_ID: 'B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7',
  PROMO_BANNER_NAME: 'new-cars',
  CINCH_URL: 'https://www.cinch.co.uk',
  CINCH_APP_URL: 'https://mobile.snc-prod.aws.cinch.co.uk',
  TRUSTPILOT_URL: 'https://trustpilot.snc-prod.aws.cinch.co.uk',
  STORYBLOK_BFF_COMPONENT: 'https://storyblok-bff.snc-prod.aws.cinch.co.uk',
  CONSUMER_VALUATIONS_SERVICE_URL:
    'https://consumer-valuations.cnv-prod.aws.cinch.co.uk',
  CINCH_CHARGE_CARD_REQUEST_URL:
    'https://extras-cinch-charge-card.cnv-prod.aws.cinch.co.uk',
  CINCH_CHARGE_CARD_REQUEST_API_KEY: 'R48mFOTC6BamHbg1LR8k97fvGXOBOweg1PsHdERV',
  PRODUCT_DETAIL_SERVICE_URL: 'https://product.api.cinch.co.uk',
  RESERVATION_STATUS_URL: 'https://orders.api.cinch.co.uk/reservation-status',
  INVENTORY_SERVICE_HISTORY_URL:
    'https://service-history.api.cinch.co.uk/basic',
  IOS_APP_STORE_URL:
    'https://apps.apple.com/gb/app/cinch-cars-without-the-faff/id1641060889',
  ANDROID_APP_STORE_URL:
    'https://play.google.com/store/apps/details?id=com.cinchapp',
  ADMIN_FEE_RETURN_TO_CHECKOUT: 'true',
  ADMIN_FEE_VALUE: '9900',
  ADMIN_FEE_LOYALTY: 'true',
  UNSUBSCRIBE_SERVICE_URL:
    'https://communication-v2-user-prefs.api.cinch.co.uk/unsubscribe',
  UNSUBSCRIBE_MINIMUM_DURATION: '3000',
  CHECKOUT_RESERVATIONS_DECOUPLING: 'true',
  CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: 'false',
  RESERVATION_SERVICE_URL:
    'https://reservations.cnv-prod.aws.cinch.co.uk/source/orders',
  DELIVERY_SLOT_AVAILABILITY_SERVICE_URL:
    'https://delivery.api.cinch.co.uk/delivery-slots',
  LOGISTICS_FEES_SERVICE_URL: 'https://logistics-fees.snp-prod.aws.cinch.co.uk',
  LOGISTICS_ROUTING_SERVICE_URL:
    'https://logistics-routing.snp-prod.aws.cinch.co.uk',
  FINANCE_APPLICATION_SERVICE_URL:
    'https://finance-application.api.cinch.co.uk',
  FINANCE_OFFER_SERVICE_URL: 'https://finance-offer.api.cinch.co.uk',
  FINANCE_SERVICE_URL: 'https://finance.api.cinch.co.uk',
  FINANCE_QUOTE_SERVICE_URL: 'https://finance-quote.pnf-prod.aws.cinch.co.uk',
  FINANCE_SOFT_SEARCH_URL_PATH: '/finance-eligibility',
  PAYMENT_LINK_SERVICE_URL: 'https://payment-link.cnv-prod.aws.cinch.co.uk',
  STRIPE_PUBLISHABLE_KEY: 'pk_live_3rDkEJzP58ZdTSIqCDS7XoAy00NjjZYQGR',
  GAP_SERVICE_URL: 'https://gap-insurance.cnv-prod.aws.cinch.co.uk',
  SERVICING_AND_WARRANTY_FLAG: 'false',
  DISABLE_CINCHCARE: 'false',
  GAP_INSURANCE_FLAG: 'false',
  CUSTOMER_DATA_API_KEY: '141271a4-f574-41de-9eee-962ee2674d80',
  CUSTOMER_DATA_API_URL: 'https://customer-data.api.cinch.co.uk',
  SEARCH_MULTIPLE_IMAGES: 'true',
  ENABLE_ZENDESK_SCRIPT: 'true',
  VEHICLE_CARD_V2: 'false',
  VEHICLE_OWNERSHIP_SERVICE_URL:
    'https://vehicle-ownership.onr-prod.aws.cinch.co.uk',
  ENABLE_BUY_NOW_CTA_MESSAGING: 'true',
  ENABLE_EMAIL_QUOTE: 'true',
  HOMEPAGE_FAVOURITING: 'false',
  ENABLE_PRODUCT_DETAIL_PAGE_VARIANT: 'true',
  ENABLE_QUOTES_MARKETING: 'true',
  SEARCH_FINANCE_TYPE_FILTER: 'true',
  SHOW_QUOTE_TERM_MONTHS: 'true',
  SHOW_SCORELESS_TRUSTPILOT: 'false',
  SOFT_SEARCH_CHANGES: 'true',
  PDP_SOFT_SEARCH: 'true',
  SHOW_CINCH_COVER_IN_PROFILE: 'true',
  SHOW_MULTI_TERM_VAPS_IN_PROFILE: 'true',
  SHOW_TYRE_INSURANCE_IN_PROFILE: 'true',
  SHOW_GAP_INSURANCE_IN_PROFILE: 'true',
  SHOW_SELF_SERVICE_RENEWALS_V3: 'true',
  BANK_SERVICE_URL: 'https://bank-details.cnv-prod.aws.cinch.co.uk',
  VAP_SERVICE_URL:
    'https://6gantc3nhf.execute-api.eu-west-1.amazonaws.com/prod',
  USE_REFRESH_TOKEN: 'true',
  SHOW_HELP_AND_SUPPORT_CHANGES: 'true',
  HELP_AND_SUPPORT_URL: 'https://help.cinch.co.uk/hc/en-gb/',
  SEARCH_FINANCE_CALCULATOR_CTA: 'true',
  ENABLE_SEGMENT_TRACKING_IN_USED_CARS: 'true',
  GOOGLE_GEOCODING_API_KEY: 'AIzaSyByDk23cR4OsdocVq2YuwRVr_mGs-ABrs8',
  STORE_AVAILABILITY_URL: 'https://store-availability.snp-prod.aws.cinch.co.uk',
  STORE_AVAILABILITY_KEY: 'eLjNp74jG51yIGqe8NTOS11U6UWd9axB8AumFuXi',
  GOOGLE_MAPS_BASE_URL: 'https://maps.googleapis.com/maps/api',
  SEARCH_DATA_DRIVEN_SORT_ORDER: 'true',
  NAVBAR_VALUATION_EXPERIMENT_ID: 'value-my-car-cta',
  SEARCH_FINANCE_CALCULATOR_CTA_EXPERIMENT_ID: 'search-page-finance-cta',
  VEHICLE_PURCHASE_BASE_URL:
    'https://vehicle-purchase.cnv-prod.aws.cinch.co.uk',
  SEARCH_DATA_DRIVEN_SORT_EXPERIMENT_ID: 'search-price-sort',
  ENABLE_SELL_MY_CAR: 'false',
  ENABLE_NEW_PROFILE_HEADER: 'false',
  FINANCE_APPLICATION_CHECKOUT_BANNER: 'true',
  CAR_FINANCE_SHOW_TRUST_PILOT: 'false',
  SEARCH_FREE_COLLECTION_LABELS: 'true',
  SEARCH_FREE_COLLECTION_LABELS_EXPERIMENT_ID: 'search-free-collection-labels',
  SITES_BASE_URL: 'https://sites.service.cinch.co.uk',
  SITES_API_KEY: 'IQAulZAr4f5mHavrXzZDA9ZHI6Ln75MN9oGel6rk',
  ENABLE_NEW_CARS: 'true',
  ENABLE_NEW_CARS_FINANCE: 'true',
  ENABLE_NEW_CARS_SEO: 'true',
  ENABLE_VAPS_FEATURE_CAR_MAINTENANCE: 'false',
  CAR_OVERVIEW_ACCORDIONS_EXPERIMENT_ID: 'pdp-open-accordion',
  LEAD_GEN_SERVICE_URL:
    'https://cinch-lead-generation.snc-prod.aws.cinch.co.uk',
  FIN_OFFER_COMMISSION: 'true',
  EVOLUTION_IDD_URL:
    'https://www.evolutionfunding.com/public/initial-disclosure-document/',
  FINANCE_SDD_PDF: 'Cinch_SDD_v02.pdf',
  FINANCE_COMMISSION_PDF: 'commissionV6.pdf',
  MARSHALL_PRIVACY_POLICY_URL:
    'https://www.marshall.co.uk/site/privacy-notice/',
  SANTANDER_PRIVACY_POLICY_URL:
    'https://www.santanderconsumer.co.uk/your-data/privacy-policy/',
  MARSHALL_COMMISSION_STATEMENT_URL:
    'https://www.marshall.co.uk/site/finance-commission-disclosure-statement/',
  SEARCH_NEW_CARS: 'true',
  NEW_CARS_API_URL: 'new-cars',
  FINANCE_SOFT_SEARCH_V2: 'true',
  FINANCE_SOFT_SEARCH_URL_V2:
    'https://finance-soft-search.pnf-prod.aws.cinch.co.uk',
  ENABLE_COMPARE_BUTTON: 'false',
  FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING: 'true',
  CINCH_SERVICING_URL: 'https://cinch-servicing.onr-prod.aws.cinch.co.uk',
  NEW_CARS_FILTERS_FLAG: 'false',
  PROPOSAL_SUBMISSION_URL:
    'https://proposal-submission.pnf-prod.aws.cinch.co.uk',
  PROPOSAL_SUBMISSION_API_KEY: '04KS2uUH2b1dy1r7ztQqaGforFOFdQp4vVazxmxg',
  IDEAL_POSTCODES_URL: 'https://api.ideal-postcodes.co.uk',
  IDEAL_POSTCODES_API_KEY: 'ak_kdejaxrppYWZNgyl3pLl03aueGKgp',
  ENABLE_SERVICE_BOOKING: 'true',
  AWIN_SERVICE_URL: 'https://awin.cnv-prod.aws.cinch.co.uk',
  PART_EX_EQUITY_RELEASE: 'false',
  SEARCH_NEW_CAR_FAVOURITING: 'true',
  SEARCH_NEW_CARS_SIGN_POST_BANNER: 'true',
  SEARCH_DYNAMIC_FIN_REP: 'true',
  SEARCH_ZERO_PERCENT_APR: 'false',
  SEARCH_VIRTUAL_STOCK: 'true',
  HOME_HERO_FORM_WITH_NEW_CARS_TAB: 'false',
  SEARCH_SHARED_VEHICLE_CARD: 'true',
  ENABLE_SELL_NEW_CARS: 'false',
  SEARCH_FINANCE_OFFERS_CAROUSEL: 'false',
}
